import { Color } from "@lib/color";

interface Branding {
	vendor:string;
	logo:string;
	reportLogo:string;
	favIcon:string;
}

interface Themes {
	primaryColor:string;
	reports: {
		stripBar1Color:string;
		stripBar3Color:string;
	}
}

interface Support {
	supportEmail:string,
	supportDeskDetails:{
		departmentId:string,
		layoutId:string,
		widgetId:string,
		orgId:string
	}
}

export interface Configs {
	isWhiteLabel: boolean;
	branding: Branding;
	themes: Themes;
	support: Support;
}

export class ConfigStore {
	static configs: Configs;

	static setConfig(data: Configs) {
		ConfigStore.configs = data;
	}

	static get<T>(path: string): T | undefined {
		if (!ConfigStore.configs) return undefined;

		return path.split('.').reduce<unknown>((value, key: string) => {
			if (value && typeof value === 'object' && key in value) {
				return (value as Record<string, unknown>)[key];
			}

			return undefined;
		}, ConfigStore.configs) as T | undefined;
	}

	static primaryColor() {
		const color=ConfigStore.get<string>('themes.primaryColor');

		return Color.html(typeof color === 'string' ? color : '#5271ff');
	}
}
